import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { camelCase } from 'lodash';
import { NavLink } from 'react-router-dom-v5-compat';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import { SidebarButton } from '../SidebarButton';
import { useStyles } from './useStyles';

export const SidebarLink = ({ className, item, active, onClick, style }) => {
  const styles = useStyles();

  const handleClick = useCallback(() => {
    onClick(item);
  }, [item, onClick]);

  return (
    <SidebarButton
      className={cx(styles.root, className, {
        [styles.hasSubtitle]: Boolean(item.subtitle),
      })}
      item={item}
      active={active}
      component={NavLink}
      to={item.path}
      onClick={handleClick}
      data-testid={`NavigationSidebarLink${camelCase(item.label)}`}
      style={style}
    >
      <div>
        {item.label}
        {item.subtitle && <Typography className={styles.subtitle}>{item.subtitle}</Typography>}
      </div>
    </SidebarButton>
  );
};

SidebarLink.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SidebarLink.defaultProps = {
  className: '',
  active: false,
};
